import { createStyles } from 'antd-style';

export const useHolidayWarningDialogStyles = createStyles(() => ({
  holidayWarningDialog: {
    'div.ant-typography': {
      textAlign: 'center',
    },
  },
  buttons: {
    marginTop: 0,
  },
}));
